import ReactDOM from "react-dom/client";
import { App } from "./App.tsx";
import "./index.css";
import "@total-typescript/ts-reset";
import { fetchInitialGlobalContext } from "./utils/GlobalContext.ts";
import { injectCjkFontPreloads } from "./utils/injectCjkFontPreloads.ts";

injectCjkFontPreloads();

(async () => {
  const app = await (async () => {
    try {
      const globalContext = await fetchInitialGlobalContext();
      injectCjkFontPreloads(globalContext.locale);
      return <App globalContext={globalContext} />;
    } catch (e) {
      console.error(e);
      return <p>Error</p>;
    }
  })();

  ReactDOM.createRoot(document.getElementById("root")!).render(app);
})();
